import { render, staticRenderFns } from "./Podesavanja.vue?vue&type=template&id=da619cf8&scoped=true&"
import script from "./Podesavanja.vue?vue&type=script&lang=js&"
export * from "./Podesavanja.vue?vue&type=script&lang=js&"
import style0 from "./Podesavanja.vue?vue&type=style&index=0&id=da619cf8&prod&scoped=true&lang=css&"
import style1 from "./Podesavanja.vue?vue&type=style&index=1&id=da619cf8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da619cf8",
  null
  
)

export default component.exports